import React, { useContext, useState } from "react";
import { ProfileContext } from "../../context/ProfileContext";
import { useTranslation } from "react-i18next";

const AddBeneficiaryForm = () => {
  const [beneficiaryData, setBeneficiaryData] = useState({
    name: "",
    email: "",
    relation: "",
  });
  const { addBeneficiary } = useContext(ProfileContext);
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    addBeneficiary(beneficiaryData);
    setBeneficiaryData({ name: "", email: "", relation: "" });
  };

  return (
    <form onSubmit={handleSubmit} className="mt-6 space-y-3">
      <h3 className="font-semibold">
        {t("beneficiaries.add.title")}
      </h3>
      <input
        type="text"
        placeholder={t("beneficiaries.add.namePlaceholder")}
        className="form-control-artsy w-full"
        value={beneficiaryData.name}
        onChange={(e) =>
          setBeneficiaryData({
            ...beneficiaryData,
            name: e.target.value,
          })
        }
        required
      />
      <input
        type="email"
        placeholder={t("beneficiaries.add.emailPlaceholder")}
        className="form-control-artsy w-full"
        value={beneficiaryData.email}
        onChange={(e) =>
          setBeneficiaryData({
            ...beneficiaryData,
            email: e.target.value,
          })
        }
        required
      />
      <input
        type="text"
        placeholder={t("beneficiaries.add.relationPlaceholder")}
        className="form-control-artsy w-full"
        value={beneficiaryData.relation}
        onChange={(e) =>
          setBeneficiaryData({
            ...beneficiaryData,
            relation: e.target.value,
          })
        }
        required
      />
      <button
        type="submit"
        className="px-5 py-2.5 rounded-xl text-sm font-medium bg-black text-white hover:bg-gray-900 transition-colors"
      >
        {t("beneficiaries.add.submit")}
      </button>
    </form>
  );
};

export default AddBeneficiaryForm;
